// Minimal JWT helpers — no external dependency.
// JWT payload is base64url-encoded JSON.

export function decodeJwt (token) {
  if (!token || typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length !== 3) return null

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '==='.slice((base64.length + 3) % 4)
    return JSON.parse(decodeURIComponent(escape(atob(padded))))
  } catch (e) {
    return null
  }
}

// Treat a token without a usable `exp` claim as expired — safer than
// assuming it's still valid.
export function isTokenExpired (token) {
  const payload = decodeJwt(token)
  if (!payload || typeof payload.exp !== 'number') return true
  return payload.exp * 1000 <= Date.now()
}
